export default "__VITE_ASSET__jo_fVaKf__"